import { render, staticRenderFns } from "./form_tree.vue?vue&type=template&id=5d35f1aa&scoped=true"
import script from "./form_tree.vue?vue&type=script&setup=true&lang=js"
export * from "./form_tree.vue?vue&type=script&setup=true&lang=js"
import style0 from "./form_tree.vue?vue&type=style&index=0&id=5d35f1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d35f1aa",
  null
  
)

export default component.exports